import { createSlice } from '@reduxjs/toolkit'
import { PurchasedSanctionList } from './thunk'

export const initialState = {
    list: [],
    loading: true
}
const PurchasedSanction = createSlice({
    name: 'PurchasedSanctionList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Listing
        builder.addCase(PurchasedSanctionList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(PurchasedSanctionList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.list = data
            state.loading = false
        })
        builder.addCase(PurchasedSanctionList.rejected, (state) => {
            state.loading = false
        })
    }
})

// export const {} = SetupFee.actions
export default PurchasedSanction.reducer
